import React, { useEffect, useContext, useState } from "react";
import { selectedTextOnWordDocContext, typeOfSearchContext } from "./KwordTabs";
import * as APICalls from "./JsFiles/APICalls";
import * as wordAPI from "./JsFiles/WordAPI";
import { decodedTokenObjectContext, workItemObjectContext, userInfoObjectContext } from "./App";
import lovDataIcon from "./../../../assets/images/LovData.png";
import karnovIcon from "./../../../assets/images/Button16x16.png";
import "../style/linking.css";
import { v4 as uuidv4 } from "uuid";

export default function Linking(props) {
  const [workItemObject, setWorkItemObject] = useContext(workItemObjectContext);
  const [userInfoObject, setUserInfoObject] = useContext(userInfoObjectContext);
  const [decodedTokenObject, setDecodedTokenObject] = useContext(decodedTokenObjectContext);
  const [selectedTextOnWordDoc, setSelectedTextOnWordDoc] = useContext(
    selectedTextOnWordDocContext
  );
  const [abortController, setAbortController] = useState(new AbortController());

  useEffect(() => {
    if (isAutoPageOn() && selectedTextOnWordDoc) {
      const newAbortController = new AbortController();
      setAbortController(newAbortController);
      handleAutomaticSearch(newAbortController);
    }
  }, [selectedTextOnWordDoc]);

  async function handleAutomaticSearch(abortController) {
    if (abortController.signal.aborted) return;

    document.querySelector(".automaticSearchResult").innerHTML =
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Søker";

    try {
      let ooxml;
      if (props.typeOfSearch == "clickOnParagraph") {
        ooxml = await wordAPI.getParagraphOoxml();
      } else if (props.typeOfSearch == "selectedTextOnAutomaticTab") {
        ooxml = await wordAPI.getSelectionOoxml();
      }

      if (abortController.signal.aborted) return;
      let existingLinksArray = await wordAPI.findExistingLinks(ooxml);

      if (abortController.signal.aborted) return;
      getSearchResult(selectedTextOnWordDoc)
        .then((apiResult) => {
          if (!abortController.signal.aborted) {
            showResultAutomatic(
              apiResult,
              selectedTextOnWordDoc,
              props.typeOfSearch,
              existingLinksArray
            );
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } catch (err) {
      console.log("err", err);
    }
  }

  function isAutoPageOn() {
    let henvisningerTab = document.querySelector("button#henvisninger-tab");
    let automaticTab = document.querySelector("button#Automatic-tab");
    let isHenvisningerTabActive;
    let isAutomaticTabActive;
    if (henvisningerTab) {
      isHenvisningerTabActive = henvisningerTab.classList.contains("active");
    }
    if (automaticTab) {
      isAutomaticTabActive = automaticTab.classList.contains("active");
    }
    if (isHenvisningerTabActive && isAutomaticTabActive) {
      return true;
    }

    return false;
  }

  function getSearchResult(text) {
    return APICalls.getLinks(text, userInfoObject, workItemObject, decodedTokenObject);
  }

  function showResultManual(result, text) {
    const arrLength = result.Matches.length;

    const allResultsContainer = document.querySelector(".manualSearchResult");

    const someSpaceInHtml = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";

    if (arrLength == 0) {
      allResultsContainer.innerHTML = someSpaceInHtml + "Ingen treff fra markert tekst.";
    } else {
      allResultsContainer.innerHTML =
        someSpaceInHtml + arrLength + " resultater fra markert tekst.";

      for (let index = 0; index < arrLength; index++) {
        let div = document.createElement("div");
        div.className = "resultContainer";
        const element = result.Matches[index];
        // console.log("element", element);

        if (element.Variants.length > 1) {
          const newDiv = document.createElement("div");
          newDiv.className = "alternativeText";
          newDiv.innerHTML = "<span>Alternatives:</span>";
          div.append(newDiv);
        }
        // console.log(element);
        element.Variants.forEach((variant) => {
          // console.log("variant", variant);
          let childDiv = document.createElement("div");
          childDiv.insertAdjacentHTML("afterbegin", variant.Html);
          childDiv.firstChild.className = "resultHtml";
          const elemId = uuidv4();
          childDiv.id = elemId;
          let buttonsDiv = createButtonsDivForResult(
            element,
            variant,
            elemId,
            props.typeOfSearch,
            false
          );

          childDiv.prepend(buttonsDiv);
          if (variant.Type == "main") {
            childDiv.className = "mainResult";
            div.prepend(childDiv);
          } else {
            childDiv.className = "altResult";
            childDiv.prepend();
            div.append(childDiv);
          }
        });
        let headlineDiv = createHeadlineDivManual(element, text, index);
        div.prepend(headlineDiv);
        allResultsContainer.append(div);
      }
    }
    sendLog("Info", "Showing Manual Links result", "Manual");
    sendMetric("Manual Links result", "Manual", "Success");
  }

  function showResultAutomatic(apiResult, text, typeOfSearch, existingLinksArray) {
    const matchCount = apiResult.Matches.length;

    const allResultsContainer = document.querySelector(".automaticSearchResult");
    allResultsContainer.innerHTML = ""; // Clear previous results

    const someSpaceInHtml = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    if (matchCount == 0) {
      allResultsContainer.innerHTML =
        someSpaceInHtml +
        ` Ingen treff i ${
          typeOfSearch === "clickOnParagraph" ? "aktivt avsnitt" : "markert tekst"
        }.`;
      return;
    } else if (matchCount == 1) {
      allResultsContainer.innerHTML =
        someSpaceInHtml +
        `Et resultat fra ${
          typeOfSearch === "clickOnParagraph" ? "aktivt avsnitt" : "markert tekst"
        }.`;
    } else if (matchCount > 1) {
      allResultsContainer.innerHTML =
        someSpaceInHtml +
        matchCount +
        ` resultater fra ${
          typeOfSearch === "clickOnParagraph" ? "aktivt avsnitt" : "markert tekst"
        }.`;
    }

    apiResult.Matches.forEach((element, index) => {
      const resultContainer = document.createElement("div");
      resultContainer.className = "resultContainer";

      if (element.Variants.length > 1) {
        const alternativeTextDiv = document.createElement("div");
        alternativeTextDiv.className = "alternativeText";
        alternativeTextDiv.innerHTML = "<span>Alternatives:</span>";
        resultContainer.append(alternativeTextDiv);
      }

      element.Variants.forEach((variant, variantIndex) => {
        const variantContainer = document.createElement("div");
        variantContainer.id = uuidv4();
        variantContainer.innerHTML =
          variant.Html && variant.Html !== "</div>"
            ? variant.Html
            : `<div class='ms-ListItem-tertiaryText'>${element.Match}</div>`;

        variantContainer.firstChild.className = "resultHtml";
        if (variant.Type.toLowerCase().includes("karnov")) {
          variantContainer.classList.add("karnovResult");
        }
        variantContainer.prepend(
          createButtonsDivForResult(
            element,
            variant,
            variantContainer.id,
            typeOfSearch,
            existingLinksArray
          )
        );

        if (variantIndex === 0) {
          variantContainer.classList.add("mainResult");
          resultContainer.prepend(variantContainer);
        } else {
          variantContainer.classList.add("altResult");
          resultContainer.append(variantContainer);
        }
      });

      resultContainer.prepend(createHeadlineDivAutomatic(element, text, index));
      allResultsContainer.append(resultContainer);
    });

    sendLog("Info", "Showing Automatic Links result", "Auto");
    sendMetric("Automatic Links result", "Auto", "Success");
  }

  function createHeadlineDivAutomatic(element, text, index) {
    let div = document.createElement("div");
    let indexSpan = document.createElement("span");
    let startText = "";
    let endText = "";
    let highlightSpan = document.createElement("span");
    indexSpan.className = "headlineIndex";
    indexSpan.innerText = "(" + (index + 1) + ") ";
    highlightSpan.className = "headlineHighlight";
    highlightSpan.innerText = element.Match;
    if (element.Start < 25) {
      startText = text.slice(0, element.Start);
    } else {
      startText = "... " + text.slice(element.Start - 25, element.Start);
    }
    if (element.End < text.length - 25) {
      endText = text.slice(element.End, element.End + 25) + " ...";
    } else {
      endText = text.slice(element.End);
    }
    div.className = "resultHeadline";
    div.append(indexSpan, startText, highlightSpan, endText);
    return div;
  }

  function createHeadlineDivManual(element, text, index) {
    let div = document.createElement("div");
    let indexSpan = document.createElement("span");
    let highlightSpan = document.createElement("span");
    indexSpan.className = "headlineIndex";
    indexSpan.innerText = "(" + (index + 1) + ") ";
    highlightSpan.className = "headlineHighlight";
    highlightSpan.innerText = text;
    div.className = "resultHeadline";
    div.append(indexSpan, highlightSpan);
    return div;
  }

  function createButtonsDivForResult(element, variant, elemId, typeOfSearch, existingLinksArray) {
    let buttonsDiv = document.createElement("div");
    buttonsDiv.className = "resultButtons";
    buttonsDiv.id = elemId;
    let seeMoreButton = createSeeMoreButton(variant, elemId);
    let insertLinkButton;
    if (typeOfSearch == "clickOnParagraph" || typeOfSearch == "selectedTextOnAutomaticTab") {
      insertLinkButton = createAutomaticInsertLinkButton(
        element,
        variant,
        existingLinksArray,
        typeOfSearch
      );
    } else if (typeOfSearch == "selectedTextOnManualTab") {
      insertLinkButton = createManualInsertLinkButton(variant);
    }
    let linkButton = createLinkButton(variant);
    buttonsDiv.append(seeMoreButton, insertLinkButton, linkButton);

    return buttonsDiv;
  }

  function createSeeMoreButton(variant, elemId) {
    let div = document.createElement("div");
    let i = document.createElement("i");
    div.id = elemId;
    div.className = "resultButton seeMoreResult";
    div.title = "Se Mer";
    // if in variant.html collapse then add event listener if not disable
    if (variant.Html.includes("ms-ListItem-content")) {
      div.onclick = function () {
        seeMoreClicked(elemId);
      };
    } else {
      div.style.color = "#D3D3D3";
    }

    i.id = elemId;
    i.className = "bi bi-plus-lg";
    div.append(i);
    return div;
  }
  function createManualInsertLinkButton(variant) {
    let div = document.createElement("div");
    let i = document.createElement("i");
    div.className = "resultButton inserManualLinkResult";
    div.onclick = () => manualLinkButtonClicked(variant, div);
    i.className = "ms-Icon ms-Icon--Link";
    div.append(i);
    return div;
  }

  function createAutomaticInsertLinkButton(element, variant, existingLinksArray, typeOfSearch) {
    let variantLink = getLink(variant);
    let div = document.createElement("div");
    let i = document.createElement("i");
    div.className = "resultButton inserAutomaticLinkResult";
    div.setAttribute("start", element.Start);
    div.setAttribute("end", element.End);
    div.setAttribute("link", variantLink);

    div.onclick = () => automaticLinkButtonClicked(element, variantLink, div, typeOfSearch);
    i.className = "ms-Icon ms-Icon--Link";
    existingLinksArray.forEach((existedLinkObj) => {
      if (
        existedLinkObj.linkUrl == variantLink &&
        existedLinkObj.start == element.Start &&
        existedLinkObj.end == element.End
      ) {
        i.className = "ms-Icon ms-Icon--RemoveLink";
        div.classList.add("removeLink");
      }
    });

    div.append(i);
    return div;
  }

  function getLink(variant) {
    if (variant.Type == "karnovdraftint") {
      return (
        (APP_Environment == "production"
          ? "https://kwordweb-prod.karnovgroup.no/"
          : "https://kwordweb-dev.karnovgroup.no/") + variant.Link
      );
    } else {
      return "https://lovdata.no/pro/" + variant.Link;
    }
  }

  function createLinkButton(variant) {
    let div = document.createElement("div");
    div.className = "resultButton lovDataLinkResult";
    let insideElement;
    let link = getLink(variant);
    insideElement = document.createElement("a");
    let img = document.createElement("img");
    div.title = link;
    insideElement.href = link;
    insideElement.target = "_blank";

    if (variant.Type.toLowerCase().includes("karnov")) {
      img.src = karnovIcon;
    } else {
      img.src = lovDataIcon;
    }
    insideElement.append(img);
    div.append(insideElement);
    return div;
  }

  function seeMoreClicked(elemId) {
    let element = document.querySelector("div#" + elemId + " div.ms-ListItem-content");
    let buttonElement = document.querySelector("div.seeMoreResult#" + elemId);
    if (element.style.display != "block") {
      element.style = "display:block";
      buttonElement.style.color = "red";
      buttonElement.title = "Se mindre";
      buttonElement.firstChild.className = "bi bi-x";
    } else {
      element.style = "display:none";
      buttonElement.style.color = "";
      buttonElement.title = "Se mer";
      document.querySelector("i#" + elemId).className = "bi bi-plus-lg";
    }
  }

  function manualLinkButtonClicked(variant, div) {
    if (div.classList.contains("removeLink")) {
      wordAPI.insertHyperLinkManual("");
      div.classList.remove("removeLink");
      div.firstChild.className = "ms-Icon ms-Icon--Link";
      sendLog("Info", "RemoveLink", "Manual", variant.Link);
      sendMetric("RemoveLink", "Manual", "Success", variant.Link);
    } else {
      let link = getLink(variant);
      wordAPI.insertHyperLinkManual(link);
      div.classList.add("removeLink");
      div.firstChild.className = "ms-Icon ms-Icon--RemoveLink";
      sendLog("Info", "AddLink", "Manual", variant.Link);
      sendMetric("AddLink", "Manual", "Success", variant.Link);
    }
  }

  function automaticLinkButtonClicked(element, variantLink, div, typeOfSearch) {
    let isRemoveLink = div.classList.contains("removeLink");
    if (!isRemoveLink) {
      //add link
      wordAPI.insertHyperLinkAutomatic(element, variantLink, typeOfSearch).then(() => {
        // changing other links button
        changeAutomaticLinkButtons(element.Start, element.End);

        //change current button
        div.classList.add("removeLink");
        div.firstChild.className = "ms-Icon ms-Icon--RemoveLink";

        sendLog("Info", "AddLink", "Auto", variantLink);
        sendMetric("AddLink", "Auto", "Success", variantLink);
      });
    } else {
      //remove link
      wordAPI.insertHyperLinkAutomatic(element, "", typeOfSearch).then(() => {
        div.classList.remove("removeLink");
        div.firstChild.className = "ms-Icon ms-Icon--Link";
        sendLog("Info", "RemoveLink", "Auto", variantLink);
        sendMetric("RemoveLink", "Auto", "Success", variantLink);
      });
    }
  }

  function changeAutomaticLinkButtons(start, end) {
    let queryStr = "div.automaticSearchResult [start='" + start + "'][end='" + end + "']";
    let buttons = document.querySelectorAll(queryStr);
    buttons.forEach((button) => {
      let isRemoveLink = button.classList.contains("removeLink");
      if (isRemoveLink) {
        button.classList.remove("removeLink");
        button.firstChild.className = "ms-Icon ms-Icon--Link";
      }
    });
  }

  function handleManualSearch(text) {
    let searchedText = text;
    if (!text) {
      searchedText = document.getElementById("searchInput").value.trim();
    }
    document.querySelector(".manualSearchResult").innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Søker";
    getSearchResult(searchedText).then((result) => {
      showResultManual(result, searchedText);
    });
  }

  function pasteClicked() {
    document.getElementById("searchInput").value = selectedTextOnWordDoc;
    handleManualSearch(selectedTextOnWordDoc);
  }

  const sendLog = (level, message, method, params) => {
    APICalls.log(
      level,
      message,
      method,
      params,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  const sendMetric = (category, subCategory, status, tag, message) => {
    APICalls.logMetric(
      category,
      subCategory,
      status,
      tag,
      message,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  return (
    <div id="LinkingPage">
      <div className="linkingTabPart">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item automatic-nav-item" role="presentation">
            <button
              className="nav-link search-nav-link active"
              id="Automatic-tab"
              data-bs-toggle="tab"
              data-bs-target="#Automatic"
              type="button"
              role="tab"
              aria-controls="Automatic"
              aria-selected="false"
            >
              Automatisk
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link search-nav-link"
              id="Manual-tab"
              data-bs-toggle="tab"
              data-bs-target="#Manual"
              type="button"
              role="tab"
              aria-controls="Manual"
              aria-selected="true"
            >
              Manuelt
            </button>
          </li>
        </ul>
      </div>
      <div className="tab-content" id="tabContent">
        <div
          className="tab-pane fade show active"
          id="Automatic"
          role="tabpanel"
          aria-labelledby="Automatic-tab"
        >
          <div className="automaticSearchPage">
            <div className="resultPageDescription">
              <h2>Automatisk oppslag</h2>
              <p>
                Sett fokus på et avsnitt i worddokumentet så vil innholdet automatisk bli sjekket
                for eventuelle henvisninger.
              </p>
              <p>Du kan også markere tekst for å sjekke kun den teksten som er markert.</p>
            </div>
            <div className="automaticSearchResult"></div>
          </div>
        </div>
        <div className="tab-pane fade" id="Manual" role="tabpanel" aria-labelledby="Manual-tab">
          <div className="manualSearchPage">
            <div id="manhenvisninger" className="resultPageDescription">
              <h2>Manuelt oppslag</h2>
              <div id="searchbox">
                <input
                  type="text"
                  placeholder="Søk.."
                  name="search"
                  className="searchboxinput"
                  id="searchInput"
                />
                <button
                  onClick={() => handleManualSearch(null)}
                  className="searchboxbutton"
                  id="searchButton"
                >
                  <i className="bi bi-search"></i>
                </button>
                <button onClick={pasteClicked} className="searchboxbutton" id="searchButtonPaste">
                  <i className="bi bi-scissors"></i>
                </button>
              </div>
            </div>
            <div className="manualSearchResult"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
